import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {required,email,isValidForm} from '../../../server/validationMethods.js'
import Draft from './draft.js';
class AssistanceProgram extends Component {
render(){
    const { t, i18n } = this.props;
    return(
        <div>
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="schoolInfo">
                        <h3 style={{textTransform:'none', overflow: 'visible'}}><Trans>If anyone in your household participates in SNAP, TANF or FDPIR then students are eligible for free school meals</Trans>.</h3>
                        <p>
                        <Trans>A household is defined as a group of people, related or unrelated, that usually live together and share income and expenses</Trans>.
                        </p>
                        <p>
                        <Trans>This includes grandparents or other extended family members that are living with you</Trans>. <Trans>It also includes people that are not currently living with you, but are only away on a temporary basis, like kids that are away at college</Trans>. <Trans>It includes people regardless of age or whether they earn or receive income</Trans>.
                        </p>
                        <p><Trans>If you need more detailed information, see the ‘WHO SHOULD I INCLUDE IN MY HOUSEHOLD?’ question in Help</Trans>.</p>
                        <p><strong><Trans>If anyone in your household (including you) currently participates in any of the following programs, please select one or more of the checkboxes below</Trans>. <Trans>If not, press continue</Trans>.</strong></p>
                    </div>
                </div>
            </div>
            <Form ref={f=>this.frmProgram=f} >
            <div className="row">
                <div className="col-xs-12">
                <div className="styled-input-container styled-input--square">
                    <ul className="list-group">
                    {
                        this.props.lunchObj.assistancePrograms.map((item,k)=>{
                        return <li className="list-group-item" style={{padding:'7px 7px 0px 10px'}}>
                                  <div className="row"> 
                                    <div className="col-md-5" style={{paddingTop:'5px'}}>
                                        <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                                            <input id={'p'+k} checked={item.isApplicable} data-idx={k} type='checkbox' onChange={(e)=>{
                                                let _idx=e.target.getAttribute('data-idx');
                                                this.props.onProgramSelectChange(_idx,e.target.checked?true:false);                                            
                                            }} /> 
                                            <label htmlFor={'p'+k}> <Trans>{item.name}</Trans></label>
                                        </div>
                                    </div>
                                   { item.isApplicable? <div className="col-md-5">
                                    <div className="form-group">
                                        
                                        <div className="col-sm-7">
                                            <Input type="text" placeholder={t('Case Number')} value={item.caseNumber} data-idx={k} id={'card-'+k} onChange={(e)=>{
                                                let _idx=e.target.getAttribute('data-idx');
                                                this.props.onProgramCardNoChanged(_idx,e.target.value);
                                            }} validations={[required]} requiredmsg={t('Please provide case number')} placeHolder={t('Case No')} className="form-control" />
                                        </div>
                                    </div>
                                    </div>:null}
                                </div>
                            </li>
                        })
                    }   
                    </ul>
                    </div>
                </div>
            </div>            
            </Form>
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(3)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                       let someSelected=this.props.lunchObj.assistancePrograms.some(function (e) {
                            return e.isApplicable;
                        });
                        if(someSelected){            
                            this.frmProgram.validateAll()
                            if(!isValidForm(this.frmProgram)){
                                return false;
                            }else{
                                this.props.jumpToStep(12);
                            }                            
                        }else{
                            this.props.jumpToStep(5);
                        }
                    }}>
                        <Trans>Continue</Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} isDistrict={this.props.isDistrict}/>
                </div>
            </div>
        </div>
    )
}
}
export default translate("translations")(AssistanceProgram);


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/assistancePrograms.jsx